import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: { 
      userID: '',
      name: '',
      email: '', 
      userToggle:false,
  },
  reducers: {
    setUserID: (state, action) => {
      const {userID, name, email} = action.payload;
      state.userID=userID;
      state.name = name;
      state.email = email;
    },
    clearUserID: (state) => {
      state.userID = ''; // Clear the user ID when the user logs out
      state.name = ''; // Clear the user ID when the user logs out
      state.email = ''; // Clear the user ID when the user logs out
      state.userToggle=false;
    },
    setUserToggle:(state)=>{
      state.userToggle=true;
    }
  },
});

export const { setUserID, clearUserID, setUserToggle } = userSlice.actions;
export default userSlice.reducer;
